import { useLanguage } from './LanguageContext';

export function useT(translations) {
    const { lang } = useLanguage();
    return translations[lang];
}
